import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// import App from "@/App";        // V1 Classic
import AppV2 from "@/AppV2";      // V2 Modern - Currently Active ✅

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppV2 />
  </React.StrictMode>,
);
